// src/pages/Archive/index.jsx
import React from 'react';
import { Layout, Typography, Timeline, Card, Tag, Spin, Alert, Empty } from 'antd';
import { ClockCircleOutlined, PushpinOutlined } from '@ant-design/icons';
import AppHeader from '../../components/Header';
import AppFooter from '../../components/Footer';
import { Link } from 'react-router-dom';
import moment from 'moment';
import './index.css';

const { Content } = Layout;
const { Title } = Typography;

const Archive = ({ posts, loading, error, loggedInUser, onLogout }) => {

    if (loading) {
        return (
            <Layout className="blog-layout">
                <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />
                <Content className="blog-content archive-content">
                    <div className="loading-container">
                        <Spin size="large" tip="加载文章归档中..." />
                    </div>
                </Content>
                <AppFooter />
            </Layout>
        );
    }

    if (error) {
        return (
            <Layout className="blog-layout">
                <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />
                <Content className="blog-content archive-content">
                    <div className="error-container">
                        <Alert message="错误" description={error} type="error" showIcon />
                    </div>
                </Content>
                <AppFooter />
            </Layout>
        );
    }

    // 按年份和月份对文章进行分组
    const groupedPosts = posts.reduce((acc, post) => {
        const yearMonth = moment(post.date).format('YYYY年MM月');
        if (!acc[yearMonth]) {
            acc[yearMonth] = [];
        }
        acc[yearMonth].push(post);
        return acc;
    }, {});

    // 将分组后的文章按时间倒序排列
    const sortedGroupedPostKeys = Object.keys(groupedPosts).sort((a, b) => moment(b, 'YYYY年MM月').diff(moment(a, 'YYYY年MM月')));

    return (
        <Layout className="blog-layout">
            <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />
            <Content className="blog-content archive-content">
                <div className="archive-container">
                    <Title level={2} className="page-title">文章归档</Title>
                    {posts.length === 0 ? (
                        <Empty
                            description="暂无文章，快去发布第一篇吧！"
                            style={{ padding: '50px 0' }}
                        />
                    ) : (
                        <Timeline mode="left" className="archive-timeline">
                            {sortedGroupedPostKeys.map(yearMonth => (
                                <Timeline.Item
                                    key={yearMonth}
                                    dot={<ClockCircleOutlined style={{ fontSize: '16px' }} />}
                                >
                                    <Card title={yearMonth} className="archive-card">
                                        {groupedPosts[yearMonth]
                                            .sort((a, b) => moment(b.date).diff(moment(a.date))) 
                                            .map(post => (
                                            <div key={post.id} className="timeline-post-item">
                                                <Title level={4}><Link to={`/post/${post.id}`}>{post.title}</Link></Title>
                                                <p className="timeline-post-meta">
                                                    <span>{moment(post.date).format('YYYY-MM-DD')}</span>
                                                    <span style={{ marginLeft: '15px' }}><PushpinOutlined /></span>
                                                    {post.tags.map(tag => <Tag key={tag} color="blue" style={{ marginLeft: 5 }}>{tag}</Tag>)}
                                                </p>
                                            </div>
                                        ))}
                                    </Card>
                                </Timeline.Item>
                            ))}
                        </Timeline>
                    )}
                </div>
            </Content>
            <AppFooter />
        </Layout>
    );
};

export default Archive;
